module.exports = __webpack_public_path__ + "img/qh.15707956.jpg";